// JavaScript source code
import './styles/Library.css';
import { useState, useRef, useEffect } from 'react';
import Dropdown from './components/library/Dropdown.js'
import GameCard from './components/library/Game.js'
import { GameCardInfo } from './components/library/Game.js'
import GameImageHeader from './GameImageHeader';
import { GetAuthStatus } from './Utilities.js';
import { createPortal } from 'react-dom';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";

function LibraryPage() {
    const [popupInfo, setPopupInfo] = useState(null);
    const [launchedLibrary, setLaunchedLibrary] = useState([]);
    const [comingSoonLibrary, setComingSoonLibrary] = useState([]);
    const [authStatus, setAuthStatus] = useState(false);
    const [sort, setSort] = useState(2);
    const [sortVisible, setSortVisible] = useState(false);
    const [libReset, setLibReset] = useState(false);
    const [page, setPage] = useState(0);
    const [currPageGames, setCurrPageGames] = useState([]);

    useEffect(() => {
        const gameDataOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({'sort': sort}),
        };

        setAuthStatus(GetAuthStatus());

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetGamesLibraryIDs', gameDataOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    console.log(data);
                    setLaunchedLibrary([...data.message.filter((game) => game.DeveloperID !== 5)]);
                    setComingSoonLibrary([...data.message.filter((game) => game.DeveloperID === 5)]);
                    setPage(0);
                }
            });
    }, [sort]);

    useEffect(() => {
        setCurrPageGames([...launchedLibrary.slice(12 * page, 12 * page + 12)]);
        setLibReset(false);
    }, [launchedLibrary, page]);

    function SetPage(event) {
        console.log("Clicked");
        setPage(event.target.id);
        setLibReset(true);
    }

    function MakePageNumbers(){
        var pages = [];
        var i;
        for( i = 0; i < Math.ceil(launchedLibrary.length / 12); i++) {
            pages.push(<button className="pageButton" onClick={SetPage} id={i}>{i+1}</button>);
        }
        return pages;
    };

    function ToggleSortVisible() {
        setSortVisible(!sortVisible);
    }

    function UpdateSort(event) {
        console.log("Clicked");
        setSort(event.target.id);
        setLibReset(true);
    }

    return (
        <div className="LibraryPage">
            <div className="libraryHeader">
                <p className="libraryTitle">{webContentStrings.libraryStrings.libraryTitle}</p>
                <div className="libraryOptions">
                    <div className="libraryFilter">
                        <div className="libraryFilterContents">
                            {/*<div className="filterButton">
                                <img src="/Icon_Filter.png" />
                                <p>{webContentStrings.libraryStrings.filterTitle}</p>
                                <p>∨</p>
                            </div>*/}
                            <div className="sortParent">
                                <div className="sortButton" onClick={ToggleSortVisible}>
                                    <p>{webContentStrings.libraryStrings.sorts[sort]}</p>
                                    <p>∨</p>
                                </div>
                                {sortVisible === true && <div className="sortOptions">
                                    {webContentStrings.libraryStrings.sorts.map((sort, index) => {
                                        return <p className="sortOpt" id={index} onClick={UpdateSort}>{sort}</p>
                                    })}
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="librarySort">
                        <div className="librarySortContents">
                            <img></img>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
            

            <div className="catalogueBackground">
                {launchedLibrary.length > 0 && <div className="catalogue">
                    <div className="catalogueContrainer">
                        {libReset === false && currPageGames.map((gameInfo, index) => {
                            return <GameCard gameId={gameInfo.ID} gameInfo={gameInfo} />
                        })}
                    </div>
                    <div className="libraryPageSelector">
                        <p className="pageSelectorTitle">PAGE</p>
                        {MakePageNumbers()}
                    </div>
                </div>}
                
            </div>


            {/* <div className='comingSoon'>
                <div className='comingTitle'>
                    <h1> Coming </h1>
                    <h1 className='soon'> Soon</h1>
                </div>
                <div>
                    <GameCard />
                </div> */}
            {/* </div> */}
        </div >
    );
}

/*
            {launchedLibrary.length > 0 && <div className='libraryTitle'>
                <h1> Supported</h1>
                <h1 style={{ color: '#FFCF00', marginLeft: '15px' }}>Games</h1>
            </div>}

<div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="infoLibrary">
                        <h2 className="taglineTopLibrary">Explore</h2>
                        <h2 className="taglineBottomLibrary">Ludare Games</h2>
                        <p className="subTagLineLibrary">Explore new realms, challenge your skills, and find the <br /> perfect game for you.</p>
                        <button class="startButton" onClick={() => { (authStatus === true ? window.location.assign("/account/subscription") : window.location.assign("/login")); }}>Manage Your Subscription</button>
                    </div>
                </div>
            </div>

<div className='libraryTitle'>
                <h1> Coming Soon</h1>
            </div>

            <div className="catalogue">

                {comingSoonLibrary.map((gameInfo, index) => {
                    return <GameCard gameId={gameInfo.ID} gameInfo={gameInfo} />
                })}
            </div>
            */

export default LibraryPage;
